import React, { useContext, useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { updateTeam } from "../services/firebase";
import { UserContext } from "../providers/UserProvider";
import FlareIcon from "@material-ui/icons/Flare";
import Loading from "./Loading";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  formControl: {
    textAlign: "left",
  },
}));

export default function TeamSettings() {
  const classes = useStyles();
  const [username, setUsername] = useState("");
  const userState = useContext(UserContext);

  const history = useHistory();

  if (!userState.teamDoc?.data()) {
    return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Loading timeout={3000}>
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <FlareIcon />
            </Avatar>
            <Typography
              component="h1"
              variant="h5"
              color="inherit"
              noWrap
              className={classes.title}
            >
              Sorry, it seems like you are not on a team!
            </Typography>
          </div>
        </Loading>
      </Container>
    );
  }

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <FlareIcon />
        </Avatar>
        <Typography
          component="h1"
          variant="h5"
          color="inherit"
          noWrap
          className={classes.title}
        >
          Team {userState.teamDoc?.data().teamName}
        </Typography>
        <form
          className={classes.form}
          onSubmit={(e) => {
            e.preventDefault();
            updateTeam(userState.teamDoc.id, username);
            setUsername("");
            history.push("/dashboard");
          }}
        >
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                autoComplete="off"
                variant="outlined"
                required
                fullWidth
                id="teamName"
                label="Team Name"
                name="teamName"
                onChange={(event) =>
                  setUsername(event.target.value.trimStart().slice(0, 35))
                }
                value={username}
              />
            </Grid>
          </Grid>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
            type="submit"
          >
            Update Info
          </Button>
        </form>
      </div>
    </Container>
  );
}
